import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import { BsChevronDown } from 'react-icons/bs';
import appConfig from '../config/appConfig';

const faqs = [
  {
    question: 'What time is check-in and check-out?',
    answer:
      'Check-in starts at 12:00 PM and check-out is by 11:00 AM. If you need to arrive earlier or leave later, let our front desk know in advance and we will do our best to accommodate you, subject to availability.',
  },
  {
    question: 'Is Wi-Fi available in the rooms?',
    answer:
      'Yes, complimentary high-speed Wi-Fi is available throughout the hotel, including every guest room, the restaurant, and common areas.',
  },
  {
    question: 'Is breakfast included in the room rate?',
    answer:
      'Most of our room rates include breakfast. The exact inclusions for your selected room and dates are shown clearly before you confirm your booking.',
  },
  {
    question: 'Do you offer free cancellation?',
    answer:
      'Yes, you can cancel your booking free of charge any time before check-in. Cancellation terms for your specific rate are always shown at checkout.',
  },
  {
    question: 'Is parking available at the hotel?',
    answer:
      'Yes, we provide on-site parking for all our guests at no extra charge, so you can drive in and settle down without any worry.',
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit and debit cards, UPI, and net banking through our secure online payment gateway, as well as cash payments at the property.',
  },
  {
    question: 'Do you allow pets?',
    answer:
      "We're currently unable to accommodate pets, with the exception of trained service animals. If you have a specific requirement, please contact us before booking.",
  },
  {
    question: 'Can you arrange airport or railway station pickup?',
    answer: `Yes, we can arrange a pickup on request. Please call our front desk at ${appConfig.hotel.phone} in advance to schedule your transfer.`,
  },
];

const Questions = () => {
  return (
    <section className="pt-0 lg:pt-4 pb-4 lg:pb-8" style={{ background: '#FFFFE7' }}>
      <div className="container mx-auto lg:px-0 rounded-3xl p-4 sm:p-6 lg:p-10 shadow-xl bg-white/80">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <div className="font-tertiary uppercase text-lg sm:text-[25px] tracking-[3px] sm:tracking-[6px]">
            FAQs
          </div>
          <h2 className="font-primary text-3xl sm:text-4xl lg:text-[45px]">Frequently Asked Questions</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto text-sm sm:text-base px-2">
            Everything you need to know before your stay. Can&apos;t find your answer? Reach out to us anytime.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4">
          {faqs.map(({ question, answer }) => (
            <Disclosure
              key={question}
              as="div"
              className="border border-gray-200 rounded-xl bg-white overflow-hidden"
            >
              {({ open }) => (
                <>
                  <Disclosure.Button className="w-full flex items-center justify-between gap-3 sm:gap-4 px-4 sm:px-5 py-3 sm:py-4 text-left font-tertiary font-semibold text-sm sm:text-base text-gray-900 hover:bg-gray-50 transition-colors">
                    <span>{question}</span>
                    <BsChevronDown
                      className={`shrink-0 text-accent transition-transform duration-300 ${
                        open ? 'rotate-180' : ''
                      }`}
                    />
                  </Disclosure.Button>
                  <Transition
                    enter="transition duration-200 ease-out"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition duration-150 ease-in"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Disclosure.Panel className="px-4 sm:px-5 pb-4 sm:pb-5 text-sm sm:text-base text-gray-600 leading-relaxed">
                      {answer}
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Questions;
